import React from "react";
import FormQuestionAnswerEditForm from "../ApplicationPolicy/formQuestionAnswerEditForm";
import CustomModal from "../General/customModal";

const AnswerEditModal = (props) => {
    const {} = props;

    return (
        <CustomModal
            contentClassname={(
                props.Store.questionAnswerForEdit
                && props.Store.questionAnswerForEdit.machineName === "EstimateForMedicalExpertFees"
            ) ? "tobas__toba-modal" : ""}
            modelDepth={3}
            isOpen={props.Store.questionAnswerModalOpen}
            content={<FormQuestionAnswerEditForm
                {...props}
                checkIfQuestionIsEditable={props.checkIfQuestionIsEditable}
                questionAnswer={props.Store.questionAnswer}
                applicationUpdateAction={props.Store.applicationUpdateAction}
                question={props.Store.questionAnswerForEdit}
                opponent={props.Store.questionAnswerOpponent}
                medicalExpertFees={props.Store.questionAnswerMedicalExpertFees}
                breachCausationCp={props.breachCausationCp}
                editingSetting={props.mapEditingQuestionOrFieldToEditingSetting(props.Store.questionAnswerForEdit)}
                triggeredQuestions={props.Store.triggeredQuestionsToDisplay}
                Store = {props.Store}
                ChangeNewAppField= {props.ChangeNewAppField}
            />}
            handleClose={props.closeEditQuestionAnswerModal}
        />
    )
};

export default AnswerEditModal;